import { Button, Form, Input } from "antd";

import styles from "../index.module.less";
import { General } from "../../../util/General";
import FormInputRules from "../../../util/FormInputRules";
import CircularProgressBar from "../../common/CircularProgressBar";
import { useNavigate } from "react-router-dom";
import { RouteConstants } from "../../../constants/ApplicationConstants/RouteConstants";

type SignInFormProps = {
  handleSubmit: (data: { username: string; password: string }) => void;
  handleForgotPasswordScreen: () => void;
  loading: boolean;
};

const SignInForm = (config: SignInFormProps) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(RouteConstants.PRIVACY_POLICY);
  };
  return (
    <>
      <Form onFinish={config?.handleSubmit} layout="vertical" autoComplete="off" validateTrigger="onBlur" name="basic" className={`gx-signin-form gx-form-row0`}>
        <Form.Item name="username" label={"Username"} normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("username")]}>
          <Input name="username" />
        </Form.Item>

        <Form.Item name="password" label={"Password"} normalize={General.inputWhiteSpaceRemove} className={styles["signIn-form__password"]} rules={[FormInputRules.requiredFieldInputRule("password")]}>
          <Input.Password name="password" />
        </Form.Item>

        <div className={styles["forgot-password_div"]}>
          <span className={styles["forgot-password-text"]} onClick={handleRedirect}>
            Privacy Policy
          </span>
          <span className={styles["forgot-password-text"]} onClick={config?.handleForgotPasswordScreen}>
            Forgot Password?
          </span>
        </div>

        <Form.Item>
          <Button className={`${styles["signIn-btn"]} gx-mb-0 button-gradiant`} htmlType="submit" disabled={config?.loading || false}>
            {config?.loading ? <CircularProgressBar /> : "Login"}
          </Button>
        </Form.Item>
        {/* {true && <span className={`${styles["version"]}`}>Version: {General.formatVersionAndDate(1, 0, 0, "24-06-2024")}</span>} */}
      </Form>
    </>
  );
};

export default SignInForm;
